import dayjs from "dayjs"
import {useFindAllRealDevice} from "hooks/queries/real-device.query"
import {useRootStore} from "store/useRootStore"

export const useDashboardMap = () => {
    const {
        dashboardStore: {
            showRealDeviceInfo,
            showPathTrackingInfo,
            showImpactHistory,
            selectedDevice,
            setShowSelectedRealDeviceInfo,
            setShowPathTrackingInfo,
            setShowImpactHistory,
            selectDevice,
            pathTrackingStore,
            conditionToHide,
            setShowStatusChart,
            setShowDeviceStatusInfoList,
            showStatusChart,
        },
        envStore: {
            env
        }
    } = useRootStore()

    const {data: result} = useFindAllRealDevice()
    // const centerLatLng = {lat: 35.8242238, lng: 127.1479532}
    const centerLatLng = {lat: parseFloat(env?.center?.lat || "35.8242238") , lng: parseFloat(env?.center?.lng || "127.1479532")}
    const zoomLevel = env?.zoomLevel || 7
    const devices = result || []

    // console.log("centerLatLng : ", centerLatLng)
    const emergencyDevices = devices.filter(device => {
        if (device.communicationDevice.status !== "EMERGENCY") {
            return false
        }
        const eui = device.communicationDevice.eui;
        const condition = conditionToHide.get(eui)
        const now = dayjs()
        if (!condition) {
            return true
        } else if (dayjs(condition).isAfter(now)) {
            return false
        } else if (dayjs(condition).isBefore(now)) {
            conditionToHide.delete(eui)
            return true
        }
        return true
    })
    const powerDisconnectedDevices = devices.filter(device => {
        return device.communicationDevice?.sensorStatus?.powerDisconnected === true
    })

    return {
        devices,
        centerLatLng,
        zoomLevel,
        showRealDeviceInfo,
        showPathTrackingInfo,
        showImpactHistory,
        selectedDevice,
        setShowSelectedRealDeviceInfo,
        setShowPathTrackingInfo,
        setShowImpactHistory,
        selectDevice,
        emergencyDevices,
        pathTrackingStore,
        setShowDeviceStatusInfoList,
        setShowStatusChart,
        showStatusChart,
        powerDisconnectedDevices,
    }
}

